import { useState } from "react";
import DashboardLayout from "../../../shared/DashboardLayout";

const YourProfile = () => {
  const [formData, setFormData] = useState({
    uid: 10,
    fname: "Amir",
    lname: "Liaqat",
    email: "amir@bytebunch.com",
    contact_number: "",
    display_name: "Amir Liaqat",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formData);
  };

  return (
    <DashboardLayout>
      <form onSubmit={handleSubmit} className="m-4">
        <input type="hidden" name="uid" value={formData.uid} />
        <h2 className="my-4">Your Profile</h2>

        <div className="row form-group">
          <div className="col-md-5">
            <strong>Username:</strong>
            <p className="description fst-italic">
              You can't edit your username.{" "}
              <a href="" target="_blank" rel="noopener noreferrer">
                Contact us
              </a>
            </p>
          </div>
          <div className="col-md-5">
            <input type="text" value="amir" className="form-control" disabled />
          </div>
        </div>

        <div className="row form-group">
          <div className="col-md-5">
            <label htmlFor="fname">
              <strong>First Name:</strong> <span className="required">*</span>
            </label>
            <p className="description fst-italic">
              Length must be between 3 characters and 20 characters.
            </p>
          </div>
          <div className="col-md-5">
            <input
              type="text"
              name="fname"
              id="fname"
              className="required form-control"
              required
              pattern=".{3,20}"
              title="3 min and 20 max characters"
              value={formData.fname}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="row form-group">
          <div className="col-md-5">
            <label htmlFor="lname">
              <strong>Last Name:</strong>
            </label>
            <p className="description fst-italic">
              Length must be between 3 characters and 20 characters.
            </p>
          </div>
          <div className="col-md-5">
            <input
              type="text"
              name="lname"
              id="lname"
              className="form-control"
              value={formData.lname}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="row form-group">
          <div className="col-md-5">
            <label htmlFor="email">
              <strong>Email address:</strong>
              <span className="required">*</span>
            </label>
            <p className="description fst-italic">
              Your contact email address.
            </p>
          </div>
          <div className="col-md-5">
            <input
              type="email"
              name="email"
              id="email"
              className="required form-control"
              required
              value={formData.email}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="row form-group">
          <div className="col-md-5">
            <label htmlFor="contact_number">
              <strong>Phone#:</strong>
            </label>
          </div>
          <div className="col-md-5">
            <input
              type="text"
              name="contact_number"
              id="contact_number"
              className="required form-control"
              value={formData.contact_number}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="row form-group">
          <div className="col-md-5">
            <label htmlFor="display_name">
              <strong>Display Name:</strong> <span className="required">*</span>
            </label>
            <p className="description fst-italic">
              This is your public display name. It should be min 3 and max 20
              chars long.
            </p>
          </div>
          <div className="col-md-5">
            <input
              type="text"
              name="display_name"
              id="display_name"
              className="required form-control"
              required
              pattern=".{3,20}"
              title="3 min and 20 max characters"
              value={formData.display_name}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="row form-group">
          <div className="col-lg-3">
            <input
              type="submit"
              value="Submit"
              className="btn site_btn text-white"
            />
          </div>
        </div>
      </form>
    </DashboardLayout>
  );
};

export default YourProfile;
